import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { TeamMembersList } from '../../components/teams/TeamMembersList';
import Button from '../../components/common/Button';

export const TeamMembersPage = () => {
  const { teamId } = useParams<{ teamId: string }>();
  
  useEffect(() => {
    console.log('TeamMembersPage mounted with teamId:', teamId);
    const urlPath = window.location.pathname;
    console.log('Current URL path:', urlPath);
    
    return () => {
      console.log('TeamMembersPage unmounted');
    };
  }, [teamId]);
  
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Team Members</h1>
        <div className="flex space-x-4">
          <Link to={`/teams/${teamId}/members/invite`}>
            <Button variant="primary">Invite Members</Button>
          </Link>
        </div>
      </div>
      
      <TeamMembersList />
    </div>
  );
}; 